import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { WithUserProfileConsumer } from '../../mixins/with-user-profile-consumer';

import { styles } from './settings-styles';
import { styles as sharedStyles } from '../../styles/shared-styles';
import './settings/system-settings.js';
import './settings/group-settings.js';
import { DomainId } from '../../utility/claim-id';

@customElement('app-settings')
export class AppSettings extends WithUserProfileConsumer(LitElement) {
  static styles = [sharedStyles, styles];

  render() {
    const isSystemTenant = this.access?.hasDomain(DomainId.systemTenant);
    return html`
      ${
        isSystemTenant
          ? html`<system-settings></system-settings>`
          : html`<group-settings></group-settings>`
      }
    `;
  }
}
